// extracted by mini-css-extract-plugin
export default {"modal":"LogoutModal_modal__4Deex","text":"LogoutModal_text__r877S","button":"LogoutModal_button__ZyIAk"};